/** Dot-path get/set that also understands numeric array indices,
 *  e.g. "year_data.1.turnover". Used so every wizard question can address
 *  exactly one slot in the answers object. */

export function getPath(object, path) {
  if (!path) return undefined;
  const keys = String(path).split(".");
  let node = object;
  for (const key of keys) {
    if (node === null || node === undefined) return undefined;
    node = node[key];
  }
  return node;
}

export function setPath(object, path, value) {
  const keys = String(path).split(".");
  const root = Array.isArray(object) ? [...object] : { ...(object || {}) };
  let node = root;
  for (let i = 0; i < keys.length - 1; i += 1) {
    const key = keys[i];
    const nextKey = keys[i + 1];
    const existing = node[key];
    const shouldBeArray = /^\d+$/.test(nextKey);
    let cloned;
    if (Array.isArray(existing)) cloned = [...existing];
    else if (existing && typeof existing === "object") cloned = { ...existing };
    else cloned = shouldBeArray ? [] : {};
    node[key] = cloned;
    node = cloned;
  }
  node[keys[keys.length - 1]] = value;
  return root;
}

/** Treats "yes" / true / 1 as true so answers survive a JSON round-trip. */
export function isYes(value) {
  if (typeof value === "boolean") return value;
  if (value === null || value === undefined) return false;
  return ["yes", "true", "1"].includes(String(value).trim().toLowerCase());
}

export function isAnswered(value) {
  if (value === null || value === undefined || value === "") return false;
  return true;
}
